module.exports = __webpack_public_path__ + "img/React-ECommerce-desktop.eb0c637b.jpg";